module.exports = __webpack_public_path__ + "img/contract_person.aaa3ed0f.png";